import React from 'react'
import Map from '../../components/Company/Map'
import Address from '../../components/Company/Address'
import { Helmet } from 'react-helmet-async'
import { Section } from './Contact'

export const Return = () =>
  <>
    <Helmet>
      <title>LFH - Returning Equipment</title>
    </Helmet>
    <div className="about">
      <h1 className="mar-t-none mar-b">Returning equipment</h1>
      <Section icon="postage" title="By post or courier" className="mar-t-2">
        <p className="mar-t-none">
          If you're returning some equipment by post or courier, the address is:
        </p>
        <Address/>
      </Section>
      <Section icon="carry flip-h" title="In person" className="mar-t-2">
        <p className="mar-t-none">
          If you want to return a lens in person, rather than by post,
          you can drop it in at the above address. Please note that it
          is open from 9.00am to 4.00pm Monday to Friday.
        </p>
        <Map/>
      </Section>
    </div>
  </>

export default Return